const setCookie = (key, value, expiry = 1) => {
  const expires = new Date()
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000)
  document.cookie =
    key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;'
}

const getFocusableElements = (container) => {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

function loadScript(url) {
  var script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  script.setAttribute('defer', true)
  document.head.appendChild(script)
}

const trapFocusHandlers = {}

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

const trapFocus = (container, elementToFocus = container) => {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

const pauseAllMedia = () => {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document
    .querySelectorAll('product-model')
    .forEach((model) => model.modelViewerUI?.pause())
}

const debounce = (fn, wait) => {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

class AccordionGlobals {
  onClick(e, accordion) {
    if (accordion.oneOpen) {
      const accordionContainer = accordion.parentNode
      this.activeElement = null
      if (accordionContainer.classList.contains('js-filter')) {
        const parentFilter = accordionContainer.parentNode
        this.activeElement = parentFilter.querySelector('details[open]')
      } else {
        this.activeElement = accordionContainer.querySelector('details[open]')
      }

      if (this.activeElement && this.activeElement !== accordion.el) {
        const activeElementParent = this.activeElement.parentNode
        const activeFaqItem = {
          el: activeElementParent.querySelector('details'),
          summary: activeElementParent.querySelector('summary'),
          content: activeElementParent.querySelector('[accordion-answer]'),
          animation: null,
          duration: accordion.duration,
        }
        activeFaqItem.el.style.overflow = 'hidden'
        this.shrink(activeFaqItem)
      }
    }
    e.preventDefault()
    accordion.el.style.overflow = 'hidden'
    if (this.isClosing || !accordion.el.open) {
      this.open(accordion)
    } else if (this.isExpanding || accordion.el.open) {
      this.shrink(accordion)
    }
  }
  shrink(accordion) {
    accordion.isClosing = true
    const startHeight = `${accordion.el.offsetHeight}px`
    const endHeight = `${accordion.summary.offsetHeight}px`
    if (accordion.animation) {
      accordion.animation.cancel()
    }
    accordion.animation = accordion.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: accordion.duration,
        easing: 'ease-out',
      }
    )
    accordion.animation.onfinish = () =>
      this.onAnimationFinish(false, accordion)
    accordion.animation.oncancel = () => (accordion.isClosing = false)
  }
  open(accordion) {
    accordion.el.style.height = `${accordion.el.offsetHeight}px`
    accordion.el.open = true
    window.requestAnimationFrame(() => this.expand(accordion))
  }
  expand(accordion) {
    accordion.isExpanding = true
    const startHeight = `${accordion.el.offsetHeight}px`
    const endHeight = `${
      accordion.summary.offsetHeight + accordion.content.offsetHeight
    }px`
    if (accordion.animation) {
      accordion.animation.cancel()
    }
    accordion.animation = accordion.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: accordion.duration,
        easing: 'ease-out',
      }
    )
    accordion.animation.onfinish = () => this.onAnimationFinish(true, accordion)
    accordion.animation.oncancel = () => (accordion.isExpanding = false)
  }
  onAnimationFinish(open, accordion) {
    accordion.el.open = open
    accordion.animation = null
    accordion.isClosing = false
    accordion.isExpanding = false
    accordion.el.style.height = accordion.el.style.overflow = ''
  }
}

/**
 * Formats a given integer to a standard fraction.
 *
 * @param {Integer} num A price, with cents
 * @param {Integer} fraction
 */
const formatPrice = (num, fraction = 2) => {
  return (Number(num) / 100).toLocaleString('en-EN', {
    minimumFractionDigits: fraction,
  })
}

/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {*} src
 * @param {*} size
 */
const getImageWithSize = (src = '', size = 1000) => {
  return ('' + src).replace(/([.](?:jpe?g|png))/, `_${size}x$1`)
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')
    const summaryElements = this.querySelectorAll('summary')
    const collectionFilterOverlay = document.querySelector(
      '.collection-filters__overlay'
    )
    this.addAccessibilityAttributes(summaryElements)
    this.submitButton = this.querySelector('button[type="submit"]')

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      )

    this.submitButton?.addEventListener('click', (event) => {
      this.closeMenuDrawer(event)
    })
    this.addEventListener('keyup', this.onKeyUp.bind(this))

    if (collectionFilterOverlay)
      collectionFilterOverlay.addEventListener('click', (e) =>
        this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      )

    // this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()

    this.navMobileOverlay = this.querySelector('.js-mobile-overlay')
    if (this.navMobileOverlay) {
      this.navMobileOverlay.addEventListener('click', (e) => {
        this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      })
    }
  }

  bindEvents() {
    this.querySelectorAll('summary:not(.filter-accordion)').forEach((summary) =>
      summary.addEventListener('click', this.debouncedOnSubmit.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  debouncedOnSubmit(event) {
    debounce(this.onSummaryClick(event), 1000)
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button')
      element.setAttribute('aria-expanded', false)
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElements = document.querySelectorAll(
      '.js-filter-drawer summary[data-text]'
    )
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')

    summaryElements.forEach((element) => {
      if (element == event.target) return
      this.closeOtherDrawer(element)
    })

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement)
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )

      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
      })
    }
  }

  closeOtherDrawer(summaryElement) {
    const detailsToggle = summaryElement.closest('details')
    detailsToggle.classList.remove('menu-opening')
    detailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    detailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(false)
    this.closeAnimation(detailsToggle)
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', false)
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      )
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.classList.contains('js-filter-drawer')
      ) {
        this.closeMenuDrawer(event)
      }
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening')
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 1000) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class Collection {
  static observer = null
  static isSubmenu = false
  static loadedFirstRow = false

  static addImagesObserver() {
    const gridItems = [
      ...document.querySelectorAll('.grid__item:not(.observed)'),
    ]

    // PLP LCP: first row visible without JS – do not animate first 2 (mobile) / first 4 (desktop)
    const grid = gridItems[0]?.closest('.collection__grid')
    let firstRowItems = []
    let itemsToObserve = gridItems
    if (grid) {
      const firstRowCount = 4
      const firstRowDoms = [
        ...grid.querySelectorAll(
          ':scope > li:nth-child(-n+' + firstRowCount + ')'
        ),
      ]
      firstRowItems = gridItems.filter((item) => firstRowDoms.includes(item))
      itemsToObserve = gridItems.filter((item) => !firstRowDoms.includes(item))
    }
    const initSliders = (el) => {
      el.querySelectorAll('product-card-slider').forEach((slider) => {
        if (typeof slider.init === 'function') {
          slider.init()
        } else {
          customElements.whenDefined('product-card-slider').then(() => {
            if (typeof slider.init === 'function') slider.init()
          })
        }
      })
    }

    firstRowItems.forEach((item) => {
      item.classList.add('observed', 'is-animated')
      item.style.opacity = '1'
      initSliders(item)
    })

    const fadeIn = (el, delay = 0) => {
      el.classList.add('is-animated')
      Collection?.observer?.unobserve(el)
      initSliders(el)

      return el.animate(
        [
          { opacity: 0 },
          {
            opacity: 1,
          },
        ],
        {
          duration: 300,
          iterations: 1,
          fill: 'forwards',
          delay: delay,
        }
      )
    }

    const showPreviousProducts = (visibleIndex) => {
      for (let i = 0; i < visibleIndex; i++) {
        const item = gridItems[i]
        const animations = item.getAnimations()
        if (animations.length) {
          animations.forEach((animation) => {
            // Fast forward through delay so it fades in immediately
            const delay = animation.effect.getComputedTiming().delay
            if (delay > animation.currentTime) {
              animation.currentTime = delay
            }
          })
        } else if (!item.matches('.is-animated')) {
          fadeIn(item)
        }
      }
    }

    if (Collection.observer) {
      // If observer already exists, we'll just keep using it to observe new images
      itemsToObserve.forEach((item) => {
        item.classList.add('observed')
        Collection.observer.observe(item)
      })
    } else {
      Collection.observer = new IntersectionObserver(
        (entries) => {
          //
          const intersectingEntries = entries.filter(
            ({ target, isIntersecting }, index) => {
              // Find the grid index of the first item in this group being animated
              // so that we can make sure everything above it fades in immediately
              if (index === 0 && isIntersecting) {
                const visibleProductIndex = gridItems.findIndex(
                  (product) => product === target
                )

                // Force show all products above the current row(s) we're going to animate
                if (visibleProductIndex > 0) {
                  showPreviousProducts(visibleProductIndex)
                }
              }

              const isAnimated = target.matches('.is-animated')

              return isIntersecting && !isAnimated
            }
          )

          // If nothing is intersecting and unanimated, skip
          if (intersectingEntries.length === 0) {
            return
          }

          let delay = 0

          const totalEntries = intersectingEntries.length

          intersectingEntries.forEach(({ target }, index) => {
            fadeIn(target, delay)

            // During a fast scroll, the number of intersecting entries is large;
            // we only want to stagger the animation on the visible ones, so we're just doing the last 8ish here
            if (index >= totalEntries - 8) {
              delay = delay + 300
            }
          })
        },
        {
          root: null,
          rootMargin: '0px 0px -100px 0px',
        }
      )

      itemsToObserve.forEach((item) => {
        item.classList.add('observed')
        Collection.observer.observe(item)
      })
    }
  }

  static setSubmenu(value = false) {
    Collection.isSubmenu = value
  }
}

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()

    const detailsParentEl = this.querySelectorAll(
      '.js-menu-draw__details-parent'
    )
    const detailsChildEl = this.querySelectorAll('.js-menu-draw__details-child')
    this.handleSingleOpenDetails(detailsParentEl)
    this.handleSingleOpenDetails(detailsChildEl)
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    )

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  handleSingleOpenDetails(details) {
    details.forEach((targetDetail) => {
      targetDetail.addEventListener('click', () => {
        const openedDetails = [...details].filter((item) =>
          item.hasAttribute('open')
        )
        openedDetails.forEach((detail) => {
          if (detail !== targetDetail) detail.removeAttribute('open')
        })
      })
    })
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    )
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
    })
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    this.querySelector('.template-popup')?.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    )
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      window.pauseAllMedia()
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class AccordionItem extends HTMLElement {
  constructor() {
    super()
    this.el = this.querySelector('details')
    this.summary = this.el.querySelector('summary')
    this.content = this.el.querySelector('[accordion-answer]')
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.duration = 200
    this.oneOpen = true

    const accordion = new AccordionGlobals()
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this))
  }
}

customElements.define('accordion-item', AccordionItem)

// Check page uses mouse or tab
document.body.addEventListener('keydown', function (e) {
  if (e.keyCode === 9) {
    document.body.classList.add('using-tab')
  }
})

document.body.addEventListener('mousedown', function () {
  if (document.body.classList.contains('using-tab')) {
    document.body.classList.remove('using-tab')
  }
})

// set height
function setViewport() {
  const vw = window.innerWidth * 0.01
  const vh = window.innerHeight * 0.01

  document.documentElement.style.setProperty('--vw', `${vw}px`)
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--ratio', `${vw / vh}`)
}

setViewport()

let r = document.querySelector(':root')
r.style.setProperty('--height', window.innerHeight + 'px')
window.addEventListener('resize', function () {
  if (window.innerWidth < 990) {
    return
  }
  r.style.setProperty('--height', window.innerHeight + 'px')
  setViewport()
})

class FocusingButton extends HTMLButtonElement {
  constructor() {
    super()
    this.el = this
    this.el.addEventListener('focusin', (e) => this.focusIn())
    this.el.addEventListener('focusout', (e) => this.focusOut())
  }
  focusIn() {
    this.el.closest('.card-wrapper').classList.add('focused')
  }
  focusOut() {
    this.el.closest('.card-wrapper').classList.remove('focused')
  }
}
customElements.define('product-form-button', FocusingButton, {
  extends: 'button',
})

document.addEventListener('DOMContentLoaded', () => {
  const sections = Array.from(
    document.querySelectorAll('[data-animate-fade-in]')
  )

  const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -50px 0px',
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('animated-in')
          observer.unobserve(entry.target)
        }, 250)
      }
    })
  }, observerOptions)

  for (let section of sections) {
    observer.observe(section)
  }
})

class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.details = this.querySelector('details')
    this.input = this.querySelector('input[name="country_code"]')

    this.addEventListener('keyup', this.onKeyUp.bind(this))

    if (this.details) {
      this.details.addEventListener('focusout', this.onFocusOut.bind(this))
    }

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return
    if (this.details && this.details.open) {
      this.details.removeAttribute('open')
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.details.removeAttribute('open')
      }
    })
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.input.value = event.currentTarget.dataset.value
    if (form) form.submit()
  }
}

customElements.define('localization-form', LocalizationForm)

// Popover API polyfill
if (!Object.hasOwn(HTMLElement.prototype, 'popover')) {
  loadScript('https://cdn.jsdelivr.net/npm/@oddbird/popover-polyfill@latest')
  // Many popovers transition opacity; the CSS for that may not work when popover is not supported, so just forcing it here
  document
    .querySelectorAll('[popover]')
    .forEach((popover) => (popover.style.opacity = 1))
}
